import { render, staticRenderFns } from "./faqSvg.vue?vue&type=template&id=c32e6e0e&scoped=true"
import script from "./faqSvg.vue?vue&type=script&lang=js"
export * from "./faqSvg.vue?vue&type=script&lang=js"
import style0 from "./faqSvg.vue?vue&type=style&index=0&id=c32e6e0e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c32e6e0e",
  null
  
)

export default component.exports